/**
 * Custom Dropdown Utility
 * Replaces Bootstrap dropdown functionality
 */

class DropdownManager {
  constructor() {
    this.openDropdowns = new Set();
    this.init();
  }

  init() {
    // Add click listener to document to handle dropdown toggles and outside clicks
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-bs-toggle="dropdown"]');
      
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDropdown(toggle);
      } else {
        // Close all dropdowns when clicking outside
        this.closeAllDropdowns();
      }
    });

    // Prevent dropdown menu clicks from closing the dropdown
    document.addEventListener('click', (e) => {
      const dropdownMenu = e.target.closest('.dropdown-menu');
      if (dropdownMenu) {
        e.stopPropagation();
      }
    });

    // Close dropdowns on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllDropdowns();
      }
    });
  }

  toggleDropdown(toggle) {
    const parent = toggle.closest('.dropdown, .btn-group, .nav-item');
    if (!parent) return;

    const menu = parent.querySelector('.dropdown-menu');
    if (!menu) return;

    const isOpen = menu.classList.contains('show');
    
    // Close all other dropdowns first
    this.closeAllDropdowns();

    if (!isOpen) {
      this.openDropdown(menu, parent);
    }
  }

  openDropdown(menu, parent) {
    menu.classList.add('show');
    parent.classList.add('show');
    this.openDropdowns.add(menu);
    
    // Position the dropdown menu
    this.positionDropdown(menu, parent);
  }

  closeDropdown(menu) {
    if (!menu) return;
    
    menu.classList.remove('show');
    const parent = menu.closest('.dropdown, .btn-group, .nav-item');
    if (parent) {
      parent.classList.remove('show');
    }
    this.openDropdowns.delete(menu);
  }

  closeAllDropdowns() {
    this.openDropdowns.forEach(menu => {
      this.closeDropdown(menu);
    });
    this.openDropdowns.clear();
  }

  positionDropdown(menu, parent) {
    // Basic positioning - can be enhanced later
    const rect = parent.getBoundingClientRect();
    const menuRect = menu.getBoundingClientRect();
    const viewport = {
      width: window.innerWidth,
      height: window.innerHeight
    };

    // Check if dropdown would go off-screen to the right
    if (rect.right + menuRect.width > viewport.width) {
      menu.classList.add('dropdown-menu-end');
    } else {
      menu.classList.remove('dropdown-menu-end');
    }
  }
}

// Initialize dropdown manager when DOM is loaded
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.dropdownManager = new DropdownManager();
    });
  } else {
    window.dropdownManager = new DropdownManager();
  }
}

export default DropdownManager;